import { render, staticRenderFns } from "./mine-comment.vue?vue&type=template&id=6c069980&scoped=true&"
import script from "./mine-comment.vue?vue&type=script&lang=js&"
export * from "./mine-comment.vue?vue&type=script&lang=js&"
import style0 from "./mine-comment.vue?vue&type=style&index=0&id=6c069980&prod&lang=scss&"
import style1 from "./mine-comment.vue?vue&type=style&index=1&id=6c069980&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c069980",
  null
  
)

export default component.exports